import Relay from 'react-relay';
import { defineMessages } from 'react-intl';

export const rejectTestRunMessages = defineMessages({
    reviewVersionUnavailable: {
        id: 'snapshotTesting.rejectVersionUnavailable',
        defaultMessage: 'Cannot reject this run because the test version was not loaded. Refresh and try again.',
    },
});

/**
 * Rejection is a versioned review action. The version must be the testcase revision the reviewer
 * is looking at, as selected by the owning query; it is never guessed or defaulted.
 */
export function hasReviewVersion(testInvocation?: { version?: number | null } | null): boolean {
    return !!testInvocation && typeof testInvocation.version === 'number' && Number.isInteger(testInvocation.version);
}

export interface RejectTestRunMutationProps {
    testInvocation: {
        id: string;
        realId?: string;
        version: number;
    };
    testRun: {
        id: string;
        realId?: string;
    };
}

export default class RejectTestRunMutation extends Relay.Mutation<RejectTestRunMutationProps, any> {
    private mutationProps: RejectTestRunMutationProps;

    constructor(props: RejectTestRunMutationProps) {
        super(props as any);
        this.mutationProps = props;
    }

    getMutation() {
        return Relay.QL`mutation {rejectTestRun}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on RejectTestRunPayload {
                testInvocation {
                    id
                }
                rejectedTestRunId
                success
                conflict
                error
            }
        `;
    }

    getConfigs() {
        return [
            {
                type: 'REQUIRED_CHILDREN',
                children: [this.getFatQuery()],
            }
        ];
    }

    getVariables() {
        return {
            testRunId: this.mutationProps.testRun.realId || this.mutationProps.testRun.id,
            testInvocationId: this.mutationProps.testInvocation.realId || this.mutationProps.testInvocation.id,
            version: this.mutationProps.testInvocation.version,
        };
    }

    getOptimisticResponse() {
        return {
            rejectedTestRunId: this.mutationProps.testRun.realId || this.mutationProps.testRun.id,
            success: true,
        };
    }
}
